export default "__VITE_ASSET__B5W09Pdk__"